import { Component, OnInit } from '@angular/core';

// interfaces
import { ICliente } from 'src/app/interfaces/cliente';
import { IFacturacion } from 'src/app/interfaces/facturacion';

// servicios
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { FacturacionService } from 'src/app/services/datos/facturacion.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

// librerías externas
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
  styleUrls: ['./facturacion.component.scss']
})
export class FacturacionComponent implements OnInit {

  public loading: boolean = false;
  public enviado: boolean = false;
  datosCabecera: IFacturacion = {}

  public clientesList: ICliente[] = [];
  cliSeleccionado: string = '';

  fechaDesde: string = '';
  fechaHasta: string = '';
  public linkXls: any = {};
  public linkPdf: string = '';

  // Errores
  public errores: any = {}

  // Totales desde los hijos
  totalesGlobal: any = {};

  totalEntradas: number = 0;
  totalDevoluciones: number = 0;
  totalSalidas: number = 0;
  totalAlmacenaje: number = 0;
  totalSeguros: number = 0;

  granTotal: number = 0;
  totalesPdfName: string = '';


  constructor(
    private usuarioSrv: UsuarioService,
    private clientesSrv: ClientesService,
    private facturaSrv: FacturacionService,
    private notificacionesSrv: NotificacionesService
  ) { }

  ngOnInit(): void {
    this.granTotal = 0;
    this.cargaClientes()

    const currentDate = new Date();

    // Primer día del mes
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    this.fechaDesde = this.formatDate(firstDay);

    // Último día del mes
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    this.fechaHasta = this.formatDate(lastDay);
  }
  enviar() {
    this.enviado = true;
    this.linkXls = {};
    this.linkPdf = '';

    // validar formulario
    this.errores = {}

    const fechaDesdeOk = this.fechaDesde ? !isNaN(new Date(this.fechaDesde).getTime()) : true;
    const fechaHastaOk = this.fechaHasta ? !isNaN(new Date(this.fechaHasta).getTime()) : true;

    if (!this.cliSeleccionado) this.errores.cliSeleccionado = 'Requerido';
    if (!this.fechaDesde || !fechaDesdeOk) this.errores.fechaDesde = 'Fecha incorrecta';
    if (!this.fechaHasta || !fechaHastaOk) this.errores.fechaHasta = 'Fecha incorrecta';

    if (this.fechaDesde && this.fechaHasta && new Date(this.fechaHasta) < new Date(this.fechaDesde)) {
      this.errores.fechaHasta = 'Debe ser mayor o igual a la fecha desde';
    }

    if (Object.keys(this.errores).length) {
      console.log('enviar() ERRORES.length: ', Object.keys(this.errores).length);
      console.log('enviar() ERRORES: ', this.errores);
      return
    }

    // Todo ok 

    // fechaHasta hasta final del día
    const fechaHasta = new Date(this.fechaHasta);
    fechaHasta.setHours(23);
    fechaHasta.setMinutes(59);
    fechaHasta.setSeconds(59);

    this.datosCabecera = {
      'id_usuario': this.usuarioSrv.userdata.id!,
      'id_cliente': this.cliSeleccionado,
      'fechaDesde': this.fechaDesde,
      'fechaHasta': this.formatDate(fechaHasta),
      'exportXls': '0',
      'exportPdf': '1',
    }

    console.log('__enviar() OK datosCabecera: ', this.datosCabecera);

  }

  confirmaClick() {
    Swal.fire({
      title: '¿Enviar datos a DTX?',
      icon: 'question',
      html: `Se van a enviar estos datos de facturación a DTX <br> Se generará un fichero PDF y XLS con los datos de facturación`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {

        // Actualizar registro de tabla facturacion
        this.datosCabecera.granTotal = this.granTotal;
        this.datosCabecera.exportPdf = '1'
        console.log('__confirmaClick(), enviar a la API de DTX', this.datosCabecera);
        this.loading = true
        this.facturaSrv.confirmaPdf(this.datosCabecera)
          .subscribe(resp => {
            this.loading = false;
            if (resp.error) {
              this.notificacionesSrv.aviso('error', resp.mensaje);
              return;
            }

            // Generar pdf del resumen
            this.generarPdf();

            // Generar xls del resumen
            this.facCrearXls();
          })

        this.notificacionesSrv.aviso('success', 'Datos de facturación enviados a DTX');

      }
    })
  }



  cargaClientes() {
    this.loading = true
    this.clientesSrv.getLista()
      .subscribe(respuesta => {
        this.loading = false;
        this.clientesList = respuesta.data;
      })
  }


  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
  }


  generarPdf() {
    const datos = {
      'id_usuario': this.usuarioSrv.userdata.id!,
      'id_cliente': this.cliSeleccionado,
      'cliente': this.totalesGlobal.seguros,
      'fechaDesde': this.fechaDesde,
      'fechaHasta': this.fechaHasta,
      'exportXls': '0',
      'exportPdf': '1',

      'almacenaje': this.totalesGlobal.almacenaje,
      'devoluciones': this.totalesGlobal.devoluciones,
      'entradas': this.totalesGlobal.entradas,
      'salidas': this.totalesGlobal.salidas,
      'salidasB2B': this.totalesGlobal.salidasB2B,
      'salidasB2C': this.totalesGlobal.salidasB2C,
    }
    console.log('__generarPdf() datos', datos);

    this.loading = true;
    this.linkPdf = '';
    this.facturaSrv.facGlobal(datos).subscribe(resp => {
      this.loading = false;

      console.log('__generarPdf() resp', resp);

      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }

      this.totalesPdfName = resp.totales.pdfName;
      this.linkPdf = environment.pdfDir + '/facturacion/' + this.totalesPdfName;
    });
  }


  // Captar los totales emitidos desde los hijos

  handleTotalEntradas(value: any) {
    this.totalesGlobal.entradas = value;
    this.sumaTotales()
    console.log('__handleTotalEntradas() totalesGlobal:', this.totalesGlobal);
  }

  handleTotalDevoluciones(value: any) {
    this.totalesGlobal.devoluciones = value;
    this.sumaTotales()
    console.log('__handleTotalDevoluciones() totalesGlobal:', this.totalesGlobal);
  }

  handleTotalSalidas(value: any) {
    this.totalesGlobal.salidas = value;
    this.sumaTotales()
    console.log('__handleTotalSalidas() totalesGlobal:', this.totalesGlobal);
  }
  handleTotalSalidasB2B(value: any) {
    this.totalesGlobal.salidasB2B = value;
    console.log('__handleTotalSalidasB2B() totalesGlobal:', this.totalesGlobal);
  }
  handleTotalSalidasB2C(value: any) {
    this.totalesGlobal.salidasB2C = value;
    console.log('__handleTotalSalidasB2C() totalesGlobal:', this.totalesGlobal);
  }

  handleTotalAlmacenaje(value: number) {
    this.totalesGlobal.almacenaje = value;
    this.sumaTotales()
    console.log('__handleTotalAlmacenaje() totalAlmacenaje:', this.totalesGlobal);
  }


  handleTotalSeguros(value: number) {
    this.totalesGlobal.seguros = value;
    this.sumaTotales()
    console.log('__handleTotalSeguros() totalSeguro:', this.totalSeguros);
  }



  sumaTotales() {

    // Verificar si los totales ya están definidos
    this.totalEntradas = this.totalesGlobal.entradas?._sumas?.Importe ?? 0;
    this.totalDevoluciones = this.totalesGlobal.devoluciones?._sumas?.Importe ?? 0;
    this.totalSalidas = this.totalesGlobal.salidas?._sumas?.Importe ?? 0;
    this.totalAlmacenaje = this.totalesGlobal.almacenaje?.almacenaje._sumas?.Importe ?? 0;
    this.totalSeguros = this.totalesGlobal.seguros?.fac_seguro_total ?? 0;

    this.granTotal = this.totalEntradas
      + this.totalDevoluciones
      + this.totalSalidas
      + this.totalAlmacenaje
      + this.totalSeguros
  }

  /// AUX ////

  // Formatea una fecha como yyyy-mm-dd
  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Número de errores en el formulario
  getErroresLength(): number {
    return Object.keys(this.errores).length;
  }

  // Genera un archivo xlsx de facturación con las pestañas vacias
  facCrearXls() {
    this.loading = true;
    this.linkXls = {};

    this.datosCabecera.granTotal = this.granTotal;
    this.datosCabecera.exportXls = '1';
    this.datosCabecera.exportPdf = '1';

    console.log('__facCrearXls() datos', this.datosCabecera);

    this.facturaSrv.facCrearXls(this.datosCabecera).subscribe({
      next: (resp) => {
        this.loading = false;
        console.log('__facCrearXls() resp', resp);

        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          return;
        }

        // Xls vacio generado. Disparar a todos los componentes hijos para que generen el xls
        this.datosCabecera.exportXls = '1';
        this.datosCabecera.exportPdf = '0';


        const setXlsCompleted = () => {
          const hash = resp.data?.hash;
          if (hash) {
            this.notificacionesSrv.aviso('success', 'Ficheros Xlsx generados correctamente');
            this.linkXls.entradas = environment.xlsDir + '/facturacion/' + hash + '_entradas.xlsx';
            this.linkXls.devoluciones = environment.xlsDir + '/facturacion/' + hash + '_devoluciones.xlsx';
            this.linkXls.salidas = environment.xlsDir + '/facturacion/' + hash + '_salidas.xlsx';
            this.linkXls.seguros = environment.xlsDir + '/facturacion/' + hash + '_seguros.xlsx';

            console.log('__facCrearXls() linkXls', this.linkXls);
          } else {
            this.linkXls = '';
            this.notificacionesSrv.aviso('error', 'No se pudo obtener el hash de los archivos.');
          }
        };

        // Ejecutar setXlsTab methods y open file when completed
        Promise.all([
          new Promise<void>(resolve => { this.setXlsTabEntradas(); resolve(); }),
          new Promise<void>(resolve => { this.setXlsTabDevoluciones(); resolve(); }),
          new Promise<void>(resolve => { this.setXlsTabSalidas(); resolve(); }),
          new Promise<void>(resolve => { this.setXlsTabSeguros(); resolve(); })
        ]).then(setXlsCompleted).catch(error => {
          console.error('Error al generar las pestañas del XLS:', error);
          this.notificacionesSrv.aviso('error', 'Error al generar las pestañas del XLS.');
        });

      },
      error: (err) => {
        this.loading = false;
        console.error('Error en la solicitud facCrearXls:', err);
        this.notificacionesSrv.aviso('error', 'Error en la comunicación con el servidor.');
      }
    });
  }


  setXlsTabEntradas() {
    // XLS entradas
    this.datosCabecera.devolucion = 0;
    this.loading = true;
    this.facturaSrv.facEntradas(this.datosCabecera).subscribe(resp => {
      this.loading = false;
      console.log('__facCrearXls()->xlsEntradas', resp);
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
    });
  }


  setXlsTabDevoluciones() {
    // XLS devoluciones
    this.datosCabecera.devolucion = 1;
    this.loading = true;
    this.facturaSrv.facEntradas(this.datosCabecera).subscribe(resp => {
      this.loading = false;
      console.log('__facCrearXls()->xlsEntradas', resp);
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
    });
  }


  setXlsTabSalidas() {
    // XLS salidas
    this.loading = true;
    this.facturaSrv.facSalidas(this.datosCabecera).subscribe(resp => {
      this.loading = false;
      console.log('__facCrearXls()->setXlsTabSalidas', resp);
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
    });
  }

  setXlsTabSeguros() {
    // XLS salidas
    this.loading = true;
    this.facturaSrv.facSeguros(this.datosCabecera).subscribe(resp => {
      this.loading = false;
      console.log('__facCrearXls()->setXlsTabSeguros', resp);
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
    });
  }


}
